import { render, staticRenderFns } from "./config.vue?vue&type=template&id=39a7a33b&scoped=true&"
import script from "./config.vue?vue&type=script&lang=js&"
export * from "./config.vue?vue&type=script&lang=js&"
import style0 from "./config.vue?vue&type=style&index=0&id=39a7a33b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a7a33b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\www\\ssz_gold_backend\\multi_merchant_web\\gold_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39a7a33b')) {
      api.createRecord('39a7a33b', component.options)
    } else {
      api.reload('39a7a33b', component.options)
    }
    module.hot.accept("./config.vue?vue&type=template&id=39a7a33b&scoped=true&", function () {
      api.rerender('39a7a33b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/supplier/config.vue"
export default component.exports